

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var BandaiVideoModalConfig =
	{
		autoInit:true ,
		className:"js-bandai-video-modal" ,
		dataKey:"data-bandai-video-id" ,
		background:"rgba(0,0,0,0.75)" ,
		closeButton:{ url:"./assets/index/img/common/icon_modal_close.png" , width:"41px" , height:"auto" } ,
		loop:false
	}


//------------------------------------------------------------------------------------------------------------------------------


	BandaiVideoModal = function( )
	{
		var html = document.body.parentNode ;
		var body = document.body ;

		var _this = BandaiVideoModal = this ;
		var i;


		//     -     -     -     -     -     -     -     -     -     -


		var _root = document.createElement("div") ;
		_root.className = "js-modal" ;
		_root.style.opacity = 0 ;

		var bg = document.createElement("div") ;
		bg.className = "js-modal-bg" ;

		var con = document.createElement("div") ;
		con.className = "con" ;

		var btn_close = document.createElement("div") ;
		btn_close.className = "wrapper-btn-close" ;

		var btn_close_img = document.createElement("img") ;
		btn_close_img.className = "btn-close" ;
		btn_close_img.src = BandaiVideoModalConfig.closeButton.url ;

		var wrapper_video = document.createElement("div") ;
		wrapper_video.className = "wrapper-video" ;

		var iframe = null;
		var iframeSize = {
			x:0 ,
			y:0 ,
			w:640 ,
			h:360 ,
			scale:0 ,
			ratio:0
		} ;


		//     -     -     -     -     -     -     -     -     -     -


		setParams( _root.style , { 	zIndex:1000 , position:"fixed" ,
									width:"100%" , height:"100%" ,
									left:"0px" , top:"0px" } ) ;

		setParams( bg.style , { position:"absolute" ,
								width:"100%" , height:"100%" ,
								background:BandaiVideoModalConfig.background ,
								left:"0px" , top:"0px" } ) ;

		setParams( con.style , { 	position:"relative" , width:"auto" , height:"auto" ,
									margin:"20px" , marginTop:"19px" , borderTop:"solid 1px transparent" } ) ;

		setParams( btn_close.style , { cursor:"pointer" , position:"relative" , textAlign:"right" , right:"0px" , top:"0px" } ) ;
		setParams( btn_close_img.style , { 	position:"relative" , display:"inline-block" ,
											width:BandaiVideoModalConfig.closeButton.width , height:BandaiVideoModalConfig.closeButton.height ,
											right:"0px" , top:"0px" , marginBottom:"20px" } ) ;

		setParams( wrapper_video.style , { 	position:"relative" , left:"0px" , top:"0px" ,
											width:"100%" , height:"100%" } ) ;


		//     -     -     -     -     -     -     -     -     -     -


		btn_close.appendChild( btn_close_img ) ;
		con.appendChild(btn_close) ;
		con.appendChild(wrapper_video) ;
		_root.appendChild( bg ) ;
		_root.appendChild( con ) ;
		_root.style.visibility = "" ;


		//     -     -     -     -     -     -     -     -     -     -


		var onResize = function( )
		{
			var htmlWidth = html.offsetWidth ;
			var htmlHeight = html.offsetHeight ;

			iframeSize.scale = Math.max( 640 / (htmlWidth - 40) , 360 / (htmlHeight - 40 - 80 ) ) ;

			iframeSize.w = 640 / iframeSize.scale ;
			iframeSize.h = 360 / iframeSize.scale ;
			iframeSize.x = ((htmlWidth - 40) - iframeSize.w) / 2 ;
			iframeSize.y = ((htmlHeight - 40 - 80 ) - iframeSize.h) / 2 ;

			//

			con.style.width = iframeSize.w + "px" ;
			con.style.height = iframeSize.h + "px" ;
			con.style.left = iframeSize.x + "px" ;
			con.style.top = iframeSize.y + "px" ;

			//

			var iframe = wrapper_video.getElementsByTagName( "iframe" )[0] ;
			if (iframe)
			{
				iframe.width = iframeSize.w ;
				iframe.height = iframeSize.h ;
			}
		}
		onResize( ) ;
		window.addEventListener( "resize" , onResize ) ;


		//     -     -     -     -     -     -     -     -     -     -


		var onOpen = function( evt )
		{
			evt.preventDefault( ) ;

			var src = evt.currentTarget.href;

			openedTarget = evt.currentTarget ;

			_this.openModal( src ) ;
		}
		var openedTarget = null ;

		var onClose = function( evt )
		{
			switch( evt.type )
			{
				case "click" :
					_this.closeModal( ) ;
					btn_close_img.style.opacity = 1 ;
					break ;

				case "mouseover" :
					btn_close_img.style.opacity = 0.6 ;
					break ;

				case "mouseout" :
					btn_close_img.style.opacity = 1 ;
					break ;
			}
		}
		btn_close_img.style.opacity = 1 ;

		var removeContent = function( )
		{
			_root.parentNode.removeChild( _root ) ;
			wrapper_video.innerHTML = "" ;
		}

		bg.addEventListener( "click", onClose ) ;
		btn_close_img.addEventListener( "click" , onClose ) ;
		btn_close_img.addEventListener( "mouseover" , onClose ) ;
		btn_close_img.addEventListener( "mouseout" , onClose ) ;


		//     -     -     -     -     -     -     -     -     -     -


		var addedList = [] ;
		_this.add = function( target )
		{
			addedList.push( target ) ;
			target.addEventListener( "click" , onOpen ) ;
		}


		//     -     -     -     -     -     -     -     -     -     -


		_this.openModal = function( src )
		{
			onResize( ) ;

			if( _root.parentNode ) return ;


			body.style.overflow = "hidden" ;

			wrapper_video.innerHTML = '<iframe style="z-index:1010; position:relative; left:0px; top:0px;" width="' +
										iframeSize.w + '" height="' + iframeSize.h + '" src="' + src +
										'" frameborder="0" allowfullscreen></iframe>';

			body.appendChild(_root) ;

			opacityTween( 1 , 0.15 ) ;
		}

		_this.closeModal = function( )
		{

			if( body.style.overflow == "" ) return ;

			body.style.overflow = "" ;

			opacityTween( 0 , -0.15 , removeContent ) ;

			//

			var onclose = openedTarget.getAttribute( "data-onclose" ) ;
			if( onclose && window[onclose] )
			{
				window[onclose]( ) ;
			}
			openedTarget = null ;
		}


		//


		var opacityTween = function( to , vector , onComplete )
		{
			opacityTween.to = to ;
			opacityTween.vector = vector ;
			opacityTween.onComplete = onComplete ;
			opacityTween.act( ) ;
		}
		opacityTween.opacity = 0 ;
		opacityTween.to = 0 ;
		opacityTween.vector = 0 ;
		opacityTween.requestID = null ;
		opacityTween.onComplete = null ;
		opacityTween.act = function( )
		{
			opacityTween.requestID = window.requestAnimationFrame( opacityTween.act ) ;

			opacityTween.opacity += opacityTween.vector ;

			if( opacityTween.vector < 0 )
			{
				if( opacityTween.opacity <= opacityTween.to )	opacityTween.opacity = opacityTween.to ;
			}
			else
			{
				if( opacityTween.opacity >= opacityTween.to )	opacityTween.opacity = opacityTween.to ;
			}

			_root.style.opacity = opacityTween.opacity ;

			if( opacityTween.opacity == opacityTween.to )
			{
				window.cancelAnimationFrame( opacityTween.requestID ) ;
				if( opacityTween.onComplete )	opacityTween.onComplete( ) ;
			}
		}


		//     -     -     -     -     -     -     -     -     -     -


		_this.dispose = function( )
		{
			if( addedList.length )
			{
				for( i = 0 ; i < addedList.length ; i++ )
				{
					addedList[i].removeEventListener( "click" , onOpen ) ;
				}
				addedList = [ ] ;
			}
		}

		_this.parse = function( )
		{
			_this.dispose( ) ;

			//

			var autoSettingTarget = document.getElementsByClassName( BandaiVideoModalConfig.className ) ;

			for( i = 0 ; i < autoSettingTarget.length ; i++ )
			{
				_this.add( autoSettingTarget[i] ) ;
			}
		}
		_this.parse( ) ;


		//     -     -     -     -     -     -     -     -     -     -
	}


//------------------------------------------------------------------------------------------------------------------------------


	var setParams = function( target , initObj , execution )
	{
		if( target instanceof Array )
		{
			for( var i in target )		setParams( target[i] , initObj ) ;
			return ;
		}

		//    -    -    -    -    -    -    -    -    -

		if( target && initObj )
		{
			for( var paramStr in initObj )
			{
				if( execution || target[paramStr] != undefined )
				{
					if( initObj[paramStr] instanceof Function )
					{
						target[paramStr] = initObj[paramStr] ;
					}
					else if( initObj[paramStr] instanceof Object )
					{
						setParams( target[paramStr] , initObj[paramStr] ) ;
					}
					else
					{
						target[paramStr] = initObj[paramStr] ;
					}
				}
			}
		}
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									window.mozRequestAnimationFrame	||
									window.msRequestAnimationFrame ||
									window.oRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;

	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									window.mozCancelAnimationFrame ||
									window.msCancelAnimationFrame ||
									window.oCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	if( BandaiVideoModalConfig.autoInit )
	{
		document.readyState === "complete"
			? setTimeout( function(){ new BandaiVideoModal( ) ; } , 1 )
			: document.addEventListener( "DOMContentLoaded", function(){ new BandaiVideoModal( ) ; } ) ;
	}


//-------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
